export default __webpack_public_path__ + "static/media/engine.8e7d2a3b.svg";